export default __webpack_public_path__ + "static/media/practice-set-cards.83c0a726.svg";